<template>
  <div class="white ma-2 pa-5 d-flex flex-column rounded-lg">
    <div class="mt-n2 mb-4">
      <h2 class="mb-2 mx-n2 text-center">Add a Verification Cell</h2>
      We hope you are enjoying Referra. We are excited to help you get rewarded
      for the leads you generate.

      <p class="mt-3">
        Before you can begin earning or claiming rewards, you must provide and verify
        a cell phone number.  This cell will be used to protect your account and ensure
        only YOU can redeem your rewards.
      </p>
    </div>
    <v-form ref="form" @submit.prevent="codeClick">
      <v-text-field 
        v-model="phone"
        v-mask="'(###) ###-####'"
        outlined dense hide-details="auto"
        class="mb-6"
        label="Cell Phone"
        placeholder=" " persistent-placeholder
        :rules="[required]"
        validate-on-blur
        autocomplete="off" autocapitalize="none"
      />
      <div class="d-flex justify-center">
        <v-btn width="60%" type="submit" color="primary">Send Code</v-btn>
      </div>
      <div class="ml-3 mt-3 text-center">
        <a style="text-decoration: underline;" @click.stop="$router.back()">Do it Later</a>
      </div>
    </v-form>
    <ErrorOverlay title="Can't add that device" v-model="error_dialog" :loading="loading">
      {{ error_message }}
    </ErrorOverlay>
  </div>
</template>
<script>

import { mapActions } from 'vuex'
import { required } from '@/lib/validations'
import ErrorOverlayMixin from '@/lib/mixins/ErrorOverlay'

export default {
  name: 'ProfileCellWizardStep1',

  mixins: [ ErrorOverlayMixin ],

  data: () => ({
    loading: false,
    phone: '',

    // validation rules
    required,
  }),

  methods: {
    ...mapActions('devices', ['createDevice']),

    async codeClick() {
      if (this.$refs.form.validate()) {
        const { phone } = this

        this.loading = true
        const result = await this.createDevice({ phone })
        this.loading = false

        if (result.ok) {
          this.$router.replace( { 
            name: 'profile/wizard/verify',
            params: { device_id: result.inserted.device_id },
          } )
        } else {
          this.error_dialog = true
          this.error_message = result.error
        }
      }
    },
  },
}
</script>